<template>
  <div id="app" class="app">
    <router-link to="/"></router-link>
    <router-view />

  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    created() {

    }
  }
</script>
<style lang="scss">

</style>
